/**
 * 压缩base64图片
 * @param {*} base64 
 */
export const compressBase64 = base64 => {
  if (base64) {
    const img = new Image();
    img.src = base64;
    // console.log(img)
    return new Promise((resolve) => {
      img.onload = () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        const url = canvas.toDataURL('image/jpeg', 0.3)
        return resolve(url);
      }
    })
  } else {
    return Promise.reject('参数为空');
  }
}
/**
 * 对象属性值为字符串的，去掉两端空格
 * @param {*} params 
 * @returns 原对象
 */
export const transformParams = params => {
  if (typeof params === 'object') {
    for (let name in params) {
      let val = params[name];
      if (val && (typeof val === 'string')) {
        params[name] = val.trim();
      }
    }
  }
  return params;
}


// WEBPACK FOOTER //
// ./src/utils/objUtils.js